export default __webpack_public_path__ + "static/media/ic_tlp_16.53bdd609.svg";